module.exports = __webpack_public_path__ + "static/img/cr_header_phone.141b46b8.png";